import { FeatureKeys } from 'api/clients/TierUsageClient'
import { useRootStore } from 'stores/RootStore'
import { useEffect, useMemo } from 'react'
import { getNextTierKey } from './useTierUsageLimits'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export interface Props {
  featureKey: FeatureKeys
}

export const useTierFeatureGate = ({ featureKey }: Props) => {
  const tierUsageStore = useRootStore().tierUsageStore
  const workspace = useCurrentWorkspace()

  const { tierLimits, currentSubscription, paymentPlans, initialized, loading } = tierUsageStore

  useEffect(() => {
    if (!initialized && !loading && workspace) {
      tierUsageStore.fetch(workspace.id)
    }
  }, [initialized, loading, tierUsageStore, workspace])

  const nextTierKey = useMemo(
    () => (currentSubscription ? getNextTierKey(currentSubscription?.plan) : undefined),
    [currentSubscription],
  )

  const nextTierPlan = useMemo(
    () => paymentPlans?.find((plan) => plan.key === nextTierKey),
    [nextTierKey, paymentPlans],
  )

  const currentTierPlan = useMemo(
    () => paymentPlans?.find((plan) => plan.key === currentSubscription?.plan),
    [paymentPlans, currentSubscription],
  )

  const featureDisabled = tierLimits?.[featureKey] === 'disabled'

  return {
    featureDisabled,
    nextTierPlan,
    currentTierPlan,
  }
}
